// CHATGPT GENERATED

(function () {
  // --- CONFIG: case-insensitive substring matches ---
  var BACKORDER_KEYWORDS = ['backorder', 'back order', 'back-order'];
  var PREORDER_KEYWORDS  = ['preorder', 'pre order', 'pre-order']; // tweak as needed

  // If both match, which should show? ('backorder' or 'preorder')
  var PRIORITY = 'backorder';

  // If you want to match only a specific option index, set this to 1/2/3; or leave null to scan title + all options
  var ONLY_OPTION_INDEX = null; // e.g., 2 to check only option2

  // ---------- Helpers ----------
  function textIncludesAny(text, list) {
    if (!text) return false;
    var t = String(text).toLowerCase();
    for (var i = 0; i < list.length; i++) {
      if (t.indexOf(String(list[i]).toLowerCase()) !== -1) return true;
    }
    return false;
  }

  function variantMatches(variant, keywords) {
    if (!variant) return false;
    var fields;
    if (ONLY_OPTION_INDEX === 1) fields = [variant.option1];
    else if (ONLY_OPTION_INDEX === 2) fields = [variant.option2];
    else if (ONLY_OPTION_INDEX === 3) fields = [variant.option3];
    else fields = [variant.title, variant.option1, variant.option2, variant.option3];

    for (var i = 0; i < fields.length; i++) {
      if (textIncludesAny(fields[i], keywords)) return true;
    }
    return false;
  }

  function $(sel) { return document.querySelector(sel); }

  function getProductJSON() {
    if (window.PRODUCT_JSON && window.PRODUCT_JSON.variants) return window.PRODUCT_JSON;
    var el = document.getElementById('ProductJSON-Bridge') ||
             document.querySelector('script[type="application/json"][id*="Product"]') ||
             document.querySelector('script[type="application/json"][data-product]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getCurrentVariantId(product) {
    var q = new URLSearchParams(location.search).get('variant');
    if (q) return Number(q);

    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && idInput.value) return Number(idInput.value);

    if (product && product.selected_or_first_available_variant && product.selected_or_first_available_variant.id)
      return Number(product.selected_or_first_available_variant.id);

    if (product && product.variants && product.variants[0]) return Number(product.variants[0].id);

    return null;
  }

  function getVariantById(product, id) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (Number(v.id) === Number(id)) return v;
    }
    return null;
  }

  function ensureBox(id, fallbackSelectorList) {
    var box = document.getElementById(id);
    if (box) return box;

    var container =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('.product-form') ||
      document.querySelector('.ProductForm__Wrapper') ||
      document.body;

    box = document.createElement('div');
    box.id = id;
    box.style.display = 'none';
    container.appendChild(box);
    return box;
  }

  function moveOnce(payload, targetBox) {
    if (!payload || !targetBox) return;
    if (payload.parentElement !== targetBox) {
      targetBox.innerHTML = '';        // keep box clean
      targetBox.appendChild(payload);  // move (not clone) so events/bindings persist
    }
  }

  function show(box, payload) {
    moveOnce(payload, box);
    payload.style.display = '';
    box.style.removeProperty('display');
  }

  function hide(box, payload) {
    if (payload) payload.style.display = 'none';
    if (box) box.style.display = 'none';
  }

  // ---------- Main ----------
  var product = getProductJSON();
  if (!product || !product.variants) return;

  var backorderBox = ensureBox('outofstock_message_backorder');
  var preorderBox  = ensureBox('outofstock_message_preorder');

  var backorderPayload = $('#backorder_payload');
  var preorderPayload  = $('#preorder_payload');

  function reevaluate() {
    var vid = getCurrentVariantId(product);
    var variant = getVariantById(product, vid);

    var isBackorder = variantMatches(variant, BACKORDER_KEYWORDS);
    var isPreorder  = variantMatches(variant, PREORDER_KEYWORDS);

    // Resolve which (if any) to show
    var showBackorder = false, showPreorder = false;
    if (isBackorder && isPreorder) {
      if (PRIORITY === 'backorder') showBackorder = true; else showPreorder = true;
    } else if (isBackorder) {
      showBackorder = true;
    } else if (isPreorder) {
      showPreorder = true;
    }

    // Toggle
    if (showBackorder) show(backorderBox, backorderPayload); else hide(backorderBox, backorderPayload);
    if (showPreorder)  show(preorderBox,  preorderPayload);  else hide(preorderBox,  preorderPayload);
  }

  // Events: cover most themes
  document.addEventListener('DOMContentLoaded', reevaluate);

  document.addEventListener('variant:change', function (evt) {
    var variant = evt && evt.detail && evt.detail.variant;
    if (variant) {
      // Fast path if theme provides the variant
      var isBackorder = variantMatches(variant, BACKORDER_KEYWORDS);
      var isPreorder  = variantMatches(variant, PREORDER_KEYWORDS);

      var showBackorder = false, showPreorder = false;
      if (isBackorder && isPreorder) {
        if (PRIORITY === 'backorder') showBackorder = true; else showPreorder = true;
      } else if (isBackorder) { showBackorder = true; }
      else if (isPreorder)   { showPreorder  = true; }

      if (showBackorder) show(backorderBox, backorderPayload); else hide(backorderBox, backorderPayload);
      if (showPreorder)  show(preorderBox,  preorderPayload);  else hide(preorderBox,  preorderPayload);
    } else {
      setTimeout(reevaluate, 0);
    }
  });

  var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  if (idInput) {
    idInput.addEventListener('change', function () { setTimeout(reevaluate, 0); });
    var mo = new MutationObserver(function () { setTimeout(reevaluate, 0); });
    mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }

  var optionControls = document.querySelectorAll(
    'form[action*="/cart/add"] select[name^="options"], ' +
    'form[action*="/cart/add"] input[type="radio"][name^="options"], ' +
    '[data-option-position], [data-value]'
  );
  optionControls.forEach(function (el) {
    el.addEventListener('change', function () { setTimeout(reevaluate, 0); });
    el.addEventListener('click',  function () { setTimeout(reevaluate, 0); });
  });

  (function (history) {
    var push = history.pushState, replace = history.replaceState;
    function wrap(fn) { return function () { var r = fn.apply(this, arguments); setTimeout(reevaluate, 0); return r; }; }
    if (push) history.pushState = wrap(push);
    if (replace) history.replaceState = wrap(replace);
    window.addEventListener('popstate', function () { setTimeout(reevaluate, 0); });
  })(window.history);

  // First run
  reevaluate();
})();
